import BarChart from "../BarChart"
import Card from "../Card"
import LineChartMain from "../LineChartMain"

import { BarChartStyle, CardGroup, CityName, GraphicGroup, LineChart, MainComponent } from "./SearchedCityElements"

type propsCity = {
  name: string;
  percentageValue1: string;
  absoluteValue1: string;
  percentageValue2: string;
  absoluteValue2: string;
  percentageValue3: string;
  absoluteValue3: string;
  lineChartData: [number] | undefined;
  barChartData: { name: string, data: [number | undefined] }[];
}

export default function SearchedCity(props: propsCity) {
  return (props.name !== null && props.name !== "" ? <MainComponent>
    <CityName>{props.name}</CityName>
    <CardGroup>
      <Card title="1&#170; dose da vacina" percentageValue={props.percentageValue1} absoluteValue={props.absoluteValue1} />
      <Card title="2&#170; dose da vacina" percentageValue={props.percentageValue2} absoluteValue={props.absoluteValue2} />
      <Card title="Dose de Reforço" percentageValue={props.percentageValue3} absoluteValue={props.absoluteValue3} />
    </CardGroup>
    <GraphicGroup>
      <LineChart>
        <LineChartMain
          title="Quantidade de vacinados totalmente"
          yTitle="Quantidade Absoluta Vacinados"
          seriesName="Imunizados em %"
          intervalPoint={31 * 24 * 3600 * 1000}
          startPoint={Date.UTC(2021, 0, 1)}
          //@ts-ignore
          dataValues={props.lineChartData === undefined ? [] : props.lineChartData}
        />
      </LineChart>
      <BarChartStyle>
        <BarChart
          title="Comparação vacinação por doses"
          xCategories={['Jan - 2021', 'Feb - 2021', 'Mar - 2021', 'Apr - 2021', 'May - 2021', 'Jun - 2021', 'Jul - 2021', 'Aug - 2021', 'Sep - 2021', 'Oct - 2021', 'Nov - 2021', 'Dec - 2021', 'Jan - 2022', 'Feb - 2022', 'Mar - 2022', 'Apr - 2022', 'May - 2022', 'Jun - 2022', 'Jul - 2022', 'Aug - 2022', 'Sep - 2022', 'Oct - 2022', 'Nov - 2022', 'Dec - 2022',]}
          yTitle="Quantidade Absoluta Vacinados"
          seriesName="Comparativo vacinação"
          seriesData={props.barChartData}
        />
      </BarChartStyle>
    </GraphicGroup>
  </MainComponent> : <></>)
}